import logoImage from './../../images/crowcloud.png';

export default class VerifyEmailController {

	static get $inject(){
		return [
			'$stateParams',
			'AuthService'
		];
	}

	constructor($stateParams,
	            AuthService){
		AuthService.verifyEmail($stateParams['emailVerificationToken'])
			.then(res => this.status = res);
	}

	// --- VM Helpers -----------------
}




/** WEBPACK FOOTER **
 ** ./src/guest/verifyEmail/controller.js
 **/